<template>
  <nav :class="$style.navigation">
    <div :class="$style.navContent">
      <router-link
        :class="$style.appName"
        :to="{ name: 'Home'}"
      >
        <h3>Where in the world</h3>
      </router-link>
    </div>
  </nav>
</template>

<style lang="scss" module>
@import '@/assets/scss/_shared.scss';

.navContent {
  @include containerWidth;
}
.navigation {
  color: var(--clr-text);
  background-color: var(--clr-elements);
  box-shadow: $box-shadow-m;
  height: 5rem;
  display: flex;
  align-items: center;

  .appName {
    font-size: clamp(.9375rem, 4vw, 1.5rem);
    font-weight: 800;
    color: var(--clr-text);
    text-decoration: none;
    align-self: flex-start;
  }
}

</style>
